<template>
    <div class="has-text-centered">
            <div  class="modal-container has-background-white has-text-centered">
                <div class="delete is-pulled-right right10 is-large has-background-grey-light" @click="$emit('close')"></div>
                <br><br>
        
                <div  id="qrDiv" ref="dDiv">        
                    <qrcode-vue id="qr" :value="toPrint" :size="size" level="H"  class="is-inline-block marginAutod"></qrcode-vue>
                    <div class="top5 has-text-dark font36" >slink.com/<b>{{slink}}</b></div>
                </div>
                
                <div v-if="showMsg" class="is-size-6 has-text-turk">Please use a computer to download QR code.</div>
                <button id="dnButt" class="button is-turk top15" download="download.png" @click="dnld" :disabled="showMsg">DOWNLOAD</button>
                <br/>
            </div>
            <br/>

           
    </div>
</template>

<script>
import * as htmlToImage from 'html-to-image';
//import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import QrcodeVue from 'qrcode.vue'
var download = require("downloadjs")

export default {
    props: ['slink'],
    components: {
        QrcodeVue
    },
    data: function(){
        return {
            size: 350,
            showMsg: false
        }
    },

    mounted: function(){
        if(window.mobileAndTabletCheck()){
                this.showMsg = true  
        }    
    },



    methods: {
        dnld: function(){

           

            az.addRemSpinner(true, 'id', 'dnButt')
            var self = this;
             //document.getElementById('qr').style.transform = 'scale(1,1)'
             
            var node = this.$refs.dDiv

            htmlToImage.toPng(node,  {pixelRatio: 2})
            .then(function (dataUrl) {
                download(dataUrl, 'QR-slink.png');       
                self.$emit('close')
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });
           

        }
    }, 

    computed: {
        toPrint: function(){
            return 'slink.com/' + this.slink
        }
    }

}
</script>

<style scoped>
   
   
    .modal-container {
        display: inline-block;
        margin: 0 auto;
        min-height: 330px;
        border-radius: 15px;
        overflow: hidden;
        border-top: 6px solid #50abc7;
        padding: 15px
    }
    .whiteInput{
        background-color: whitesmoke !important;
        width: 150px;
    }

</style>



// WEBPACK FOOTER //
// src/components/ModalQR.vue